<template>
  <div>
    <el-form
      :inline="true"
      :model="formInline"
      class="demo-form-inline"
    >
      <el-form-item label="商品名称">
        <el-input
          v-model="formInline.name"
          placeholder="商品名称"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          @click="onSubmit"
        >
          查询
        </el-button>
      </el-form-item>
    </el-form>
    <!-- <div>
      <el-button
        @click="operation('multipleDel', tableData)"
      >批量选择</el-button>
    </div> -->
    <el-table
      ref="multipleTable"
      v-loading="loading"
      :data="tableData"
      border
      :header-cell-style="{'background': '#D9DDE1', 'color': '#0D0202', 'font-weight': 400}"
      element-loading-text="拼命加载中"
      :row-key="getRowKey"
      style="width: 100%"
      @selection-change="handleSelectionChange"
    >
      <el-table-column
        type="selection"
        :reserve-selection="true"
        width="55"
      >
      </el-table-column>
      <el-table-column
        prop="id"
        label="商品ID"
        width="90"
      />
      <el-table-column
        prop="imagePath"
        label="商品图片"
        width="150"
      >
        <template slot-scope="scope">
          <div>
            <img
              :src="scope.row.imagePath"
              alt=""
              style="width: 100px;height: 100px;"
            >
          </div>
        </template>
      </el-table-column>
      <el-table-column
        prop="name"
        label="商品名称"
        width="120"
      />
      <el-table-column
        prop="sellPrice"
        label="销售价（元）"
      />
      <el-table-column
        prop="sku"
        label="商品规格"
      />
    </el-table>
    <el-pagination
      v-if="tableData && tableData.length > 0"
      :current-page="pagination.currentPage"
      :page-sizes="[10, 20, 30, 50]"
      :page-size="pagination.nowPageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="pagination.count"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    />
    <div class="operate-footer">
      <el-button @click="cancel">
        取消
      </el-button>
      <el-button
        type="primary"
        @click="submit"
      >
        确定
      </el-button>
    </div>
  </div>
</template>
<script>
export default {
  name: 'GoodsDialog',
  data() {
    return {
      tableData: [],
      loading: false,
      formInline: {
        name: ''
      },
      pagination: {
        currentPage: 1,
        nowPageSize: 10,
        count: 0
      },
      selectGoods: [] // 选中的商品
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    getRowKey(row) {
      return row.skuId
    },
    // 分页控制
    handleSizeChange(val) {
      this.pagination.nowPageSize = val
      this.pagination.currentPage = 1
      this.getList()
    },
    handleCurrentChange(val) {
      this.pagination.currentPage = val
      this.getList()
    },
    getList() {
      this.loading = true
      this.$axios({
        method: 'post',
        url: this.$api.DistributeController.selectGoodsForDistributePage,
        data: {
          currentPage: this.pagination.currentPage,
          pageSize: this.pagination.nowPageSize,
          goodsName: this.formInline.name
        }
      }).then((res) => {
        if (res.code === 0) {
          this.tableData = res.data.records
          this.tableData.forEach((item, index) => {
            item.time = new Date()
          })
          this.pagination.count = Number(res.data.total)
        } else {
          this.$message(r.error_msg)
        }
        this.loading = false
      })
    },
    operation(type, rows) {
      rows.forEach(row => {
        this.$refs.multipleTable.toggleRowSelection(row)
      })
    },
    submit() {
      this.$emit('setGoods', this.selectGoods)
    },
    cancel() {
      this.$emit('cancel')
    },
    handleSelectionChange(value) {
      console.log(value, '====')
      this.selectGoods = value
    },
    onSubmit() {
      this.getList()
    }
  }
}
</script>
<style scoped>
.operate-footer{
  display: flex;
  justify-content: center;
  padding: 30px;
}
</style>
